export const TRANSACTIONS_FILTERS = [
  {
    key: 'startDate',
    type: 'date',
  },
  {
    key: 'endDate',
    type: 'date',
  },
  {
    key: 'objekti_liik',
    type: 'multiselect',
    options: [
      {
        value: 'KOM',
        label: 'KOM',
      },
      {
        value: 'KASI',
        label: 'KASI',
      },
      {
        value: 'KHÕI',
        label: 'KHÕI',
      },
      {
        value: 'HÕIG',
        label: 'HÕIG',
      },
    ],
  },
  {
    key: 'hoonestatud',
    type: 'multiselect',
    options: [
      {
        value: 'T',
        label: 'JAH',
      },
      {
        value: 'F',
        label: 'EI',
      },
    ],
  },
  {
    key: 'ehitise_konstruktsioonide_materjal',
    type: 'multiselect',
    options: [
      {
        value: 'looduslik kivi',
        label: 'Looduslik kivi',
      },
      {
        value: 'metall',
        label: 'Metall',
      },
      {
        value: 'monoliitne raudbetoon',
        label: 'Monoliitne raudbetoon',
      },
      {
        value: 'monteeritav raudbetoon',
        label: 'Monteeritav raudbetoon',
      },
      {
        value: 'plastmass',
        label: 'Plastmass',
      },
      {
        value: 'puit',
        label: 'Puit',
      },
      {
        value: 'tellis',
        label: 'Tellis',
      },
      {
        value: 'väike- või suurplokk',
        label: 'Väike- või suurplokk',
      },
      {
        value: 'muu materjal',
        label: 'Muu materjal',
      },
    ],
  },
  {
    key: 'ehitise_valisseina_liik',
    type: 'multiselect',
    options: [
      {
        value: 'vahetäitega sõrestik',
        label: 'Vahetäitega sõrestik',
      },
      {
        value: 'plekk',
        label: 'Plekk',
      },
      {
        value: 'looduslik kivi',
        label: 'Looduslik kivi',
      },
      {
        value: 'betoon',
        label: 'Betoon',
      },
      {
        value: 'tsementkiudplaat',
        label: 'Tsementkiudplaat',
      },
      {
        value: 'palk',
        label: 'Palk',
      },
      {
        value: 'laudis',
        label: 'Laudis',
      },
      {
        value: 'mitmekihiline raudbetoonpaneel',
        label: 'Mitmekihiline raudbetoonpaneel',
      },
      {
        value: 'mitmekihiline teraspaneel',
        label: 'Mitmekihiline teraspaneel',
      },
      {
        value: 'plastmass',
        label: 'Plastmass',
      },
      {
        value: 'klaas',
        label: 'Klaas',
      },
      {
        value: 'tellis',
        label: 'Tellis',
      },
      {
        value: 'väike- või suurplokk',
        label: 'Väike- või suurplokk',
      },
      {
        value: 'muu materjal',
        label: 'Muu materjal',
      },
    ],
  },
  {
    key: 'hooneosa_soojavarustuse_liik',
    type: 'multiselect',
    options: [
      {
        value: 'kaugküte',
        label: 'Kaugküte',
      },
      {
        value: 'lokaalküte',
        label: 'Lokaalküte',
      },
      {
        value: 'kohtküte',
        label: 'Kohtküte',
      },
      {
        value: 'muu',
        label: 'Muu',
      },
    ],
  },
  {
    key: 'ehr_purpose',
    type: 'multiselect',
    options: [
      {
        value: '11101',
        label: 'Üksikelamu',
      },
      {
        value: '11102',
        label:
          'Ridaelamu või kaksikelamu sektsioon (juhul kui on oma katus ja sissepääs maapinnalt)',
      },
      {
        value: '11103',
        label: 'Suvila, aiamaja',
      },
      {
        value: '11212',
        label: 'Kahe korteriga elamu',
      },
      {
        value: '11221',
        label: 'Ridaelamu',
      },
      {
        value: '11222',
        label: 'Muu kolme või enama korteriga elamu',
      },
      {
        value: '11311',
        label: 'Päevakeskus',
      },
      {
        value: '11312',
        label: 'Tugikodu',
      },
      {
        value: '11313',
        label: 'Varjupaik',
      },
      {
        value: '11314',
        label: 'Lastekodu',
      },
      {
        value: '11315',
        label: 'Noortekodu',
      },
      {
        value: '11316',
        label: 'Üldhooldekodu',
      },
      {
        value: '11317',
        label: 'Koolkodu',
      },
      {
        value: '11318',
        label: 'Sotsiaalse rehabilitatsiooni keskus',
      },
      {
        value: '11319',
        label: 'Erihooldekodu',
      },
      {
        value: '11321',
        label: 'Ühiselamu üliõpilastele või õpilastele',
      },
      {
        value: '11322',
        label: 'Ühiselamu teistele sotsiaalsetele gruppidele',
      },
      {
        value: '12111',
        label: 'Hotell, motell, külalistemaja',
      },
      {
        value: '12121',
        label: 'Puhkeküla või puhkelaagri majutushoone',
      },
      {
        value: '12123',
        label: 'Hostel',
      },
      {
        value: '12129',
        label: 'Muu lühiajalise majutuse hoone',
      },
      {
        value: '12131',
        label: 'Restoran',
      },
      {
        value: '12132',
        label: 'Kohvik, baar või söökla',
      },
      {
        value: '12139',
        label: 'Muu toitlustushoone',
      },
      {
        value: '12201',
        label: 'Büroohoone',
      },
      {
        value: '12311',
        label: 'Kaubandushoone',
      },
      {
        value: '12314',
        label: 'Kiosk',
      },
      {
        value: '12317',
        label: 'Oksjoni-, turu- või näitusehall',
      },
      {
        value: '12319',
        label: 'Muu kaubandushoone',
      },
      {
        value: '12331',
        label: 'Ilu- ja isikuteenuste hoone',
      },
      {
        value: '12332',
        label: 'Sõidukite teeninduse hoone',
      },
      {
        value: '12339',
        label: 'Muu teenindushoone',
      },
      {
        value: '12411',
        label: 'Lennujaama hoone',
      },
      {
        value: '12413',
        label: 'Raudteejaama hoone',
      },
      {
        value: '12415',
        label: 'Bussijaama hoone',
      },
      {
        value: '12416',
        label: 'Sadamahoone',
      },
      {
        value: '12419',
        label: 'Muu terminalihoone',
      },
      {
        value: '12431',
        label: 'Garaaž',
      },
      {
        value: '12432',
        label: 'Parkimismaja',
      },
      {
        value: '12439',
        label: 'Muu garaaž',
      },
      {
        value: '12511',
        label: 'Maavarade kaevandamise ja töötlemise hoone',
      },
      {
        value: '12512',
        label: 'Energeetikatööstuse hoone',
      },
      {
        value: '12513',
        label: 'Keemiatööstuse hoone',
      },
      {
        value: '12514',
        label: 'Toiduainetetööstuse hoone',
      },
      {
        value: '12515',
        label: 'Ehitusmaterjalide ja -toodete tööstuse hoone',
      },
      {
        value: '12516',
        label: 'Kergetööstuse hoone',
      },
      {
        value: '12517',
        label: 'Puidutööstuse hoone',
      },
      {
        value: '12518',
        label: 'Masina- ja seadmetööstuse hoone',
      },
      {
        value: '12519',
        label: 'Muu tööstushoone',
      },
      {
        value: '12521',
        label: 'Toiduainete laohoone',
      },
      {
        value: '12523',
        label: 'Vedelkütuse-, küttegaasi- jm terminali hoidlahoone',
      },
      {
        value: '12525',
        label: 'Külmhoone',
      },
      {
        value: '12529',
        label: 'Muu laohoone',
      },
      {
        value: '12611',
        label: 'Teater, kino, kontserdi- ja universaalsaalide hoone',
      },
      {
        value: '12615',
        label: 'Klubi, rahvamaja',
      },
      {
        value: '12616',
        label: 'Tantsusaal, diskoteek, ööklubi',
      },
      {
        value: '12617',
        label: 'Kasiino',
      },
      {
        value: '12618',
        label: 'Loomaaia või botaanikaaia hoone',
      },
      {
        value: '12619',
        label: 'Muu meelelahutushoone',
      },
      {
        value: '12621',
        label: 'Muuseum, kunstigalerii',
      },
      {
        value: '12623',
        label: 'Raamatukogu',
      },
      {
        value: '12624',
        label: 'Arhiiv',
      },
      {
        value: '12631',
        label:
          'Koolieelne lasteasutus (lastesõim, -aed, päevakodu, lasteaed-algkool)',
      },
      {
        value: '12632',
        label: 'Põhikooli või gümnaasiumi õppehoone',
      },
      {
        value: '12633',
        label: 'Kutseõppeasutuse õppehoone',
      },
      {
        value: '12634',
        label: 'Ülikooli, rakenduskõrgkooli õppehoone',
      },
      {
        value: '12635',
        label: 'Teadus- ja metoodikaasutuse hoone',
      },
      {
        value: '12639',
        label: 'Muu haridus- või teadushoone',
      },
      {
        value: '12641',
        label: 'Haigla',
      },
      {
        value: '12643',
        label: 'Kinnipidamiskoha haigla',
      },
      {
        value: '12644',
        label: 'Ambulatoorse arstiabi osutamise hoone',
      },
      {
        value: '12645',
        label: 'Sanatoorium, spaa',
      },
      {
        value: '12646',
        label: 'Veterinaarkliinik',
      },
      {
        value: '12649',
        label: 'Muu tervishoiuhoone',
      },
      {
        value: '12651',
        label: 'Spordihall, võimla',
      },
      {
        value: '12653',
        label: 'Siseujula',
      },
      {
        value: '12654',
        label: 'Jäähall',
      },
      {
        value: '12655',
        label: 'Maneež',
      },
      {
        value: '12656',
        label: 'Lasketiiru hoone',
      },
      {
        value: '12659',
        label: 'Muu spordihoone',
      },
      {
        value: '12711',
        label: 'Loomakasvatushoone, sealhulgas karuslooma- või linnukasvatus',
      },
      {
        value: '12714',
        label: 'Teraviljakuivati',
      },
      {
        value: '12715',
        label: 'Loomasööda hoidla',
      },
      {
        value: '12718',
        label: 'Mineraalväetiste või taimekaitsevahendite hoidla',
      },
      {
        value: '12719',
        label: 'Muu põllu-, metsa-, jahi- või kalamajandushoone',
      },
      {
        value: '12721',
        label: 'Kirik, katedraal, mošee, sünagoog, palvemaja või kabel',
      },
      {
        value: '12723',
        label: 'Krematoorium',
      },
      {
        value: '12731',
        label: 'Ajalooline või kaitse all olev hoone',
      },
      {
        value: '12732',
        label: 'Muinsuskaitse all olev vare',
      },
      {
        value: '12741',
        label: 'Reoveepuhasti hoone',
      },
      {
        value: '12742',
        label: 'Karistusasutuse hoone',
      },
      {
        value: '12743',
        label: 'Päästeteenistuse hoone',
      },
      {
        value: '12744',
        label: 'Elamu, kooli vms abihoone',
      },
      {
        value: '12745',
        label: 'Katlamaja, boilerjaam',
      },
      {
        value: '12746',
        label: 'Kaevumaja',
      },
      {
        value: '12747',
        label: 'Veepuhastusjaama hoone',
      },
      {
        value: '12748',
        label: 'Jäätmekäitluse hoone',
      },
      {
        value: '12749',
        label: 'Muu erihoone',
      },
    ],
  },
]

export const TRANSACTIONS_ADDITIONAL_FILTERS = [
  {
    key: 'ad_link',
    type: 'switch',
  },
  {
    key: 'tehingu_liik',
    type: 'multiselect',
  },
  {
    key: 'tehingu_iseloom',
    type: 'multiselect',
  },
  {
    key: 'lepingu_liik',
    type: 'multiselect',
  },
  {
    key: 'muude_hoonete_selgitus',
    type: 'multiselect',
  },
  {
    key: 'myyja_liik',
    type: 'multiselect',
  },
  {
    key: 'ostja_liik',
    type: 'multiselect',
  },
  {
    key: 'markused',
    type: 'search',
    label: 'messages.transactions.filters.markused.label',
    minChar: 3,
    value: '',
  },
  {
    key: 'omandiosa_suurus',
    type: 'range',
  },
  {
    key: 'omandiosadest',
    type: 'range',
  },
  {
    key: 'elamumaa_protsent',
    type: 'range',
  },
  {
    key: 'arimaa_protsent',
    type: 'range',
  },
  {
    key: 'tootmismaa_protsent',
    type: 'range',
  },
  {
    key: 'maatulundusmaa_protsent',
    type: 'range',
  },
  {
    key: 'muu_sihtotstarve_protsent',
    type: 'range',
  },
  {
    key: 'haritav_maa',
    type: 'range',
  },
  {
    key: 'haritav_maa_osakaal',
    type: 'range',
  },
  {
    key: 'metsamaa',
    type: 'range',
  },
  {
    key: 'metsamaa_osakaal',
    type: 'range',
  },
  {
    key: 'looduslik_rohumaa',
    type: 'range',
  },
  {
    key: 'looduslik_rohumaa_osakaal',
    type: 'range',
  },
  {
    key: 'ouemaa',
    type: 'range',
  },
  {
    key: 'muu_maa',
    type: 'range',
  },
]

export const SEARCH_SLIDER_LIMITS = {
  korteri_pind: [0, 500],
  pindala: {
    H: [0, 1000],
    M: [0, 500000],
  },
}

export const SEARCH_EHR_DEFAULTS = {
  year: {
    from: null,
    to: null,
  },
  floors: {
    from: null,
    to: null,
  },
  floor: {
    from: null,
    to: null,
  },
  rooms: {
    from: null,
    to: null,
  },
  partArea: {
    from: null,
    to: null,
  },
  construction: [],
  wall: [],
  partHeating: [],
  purpose: [],
  partPurpose: [],
}

export const SEARCH_DEFAULT_UNIT = 'H'

export const PROJ_DEFINITIONS = {
  'EPSG:3301': {
    definition:
      '+proj=lcc +lat_1=59.33333333333334 +lat_2=58 +lat_0=57.51755393055556 +lon_0=24 +x_0=500000 +y_0=6375000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
    extent: [40500, 5993000, 1064500, 7017000],
    units: 'm',
  },
}

export const MAP_CENTER = [25.5, 58.7]
export const MAP_EXTENT = [20, 56, 30, 61]
export const MAP_ZOOM = 2
export const MAP_MINZOOM = 0
export const MAP_MAXZOOM = 16
export const MAP_PROJECTION = 'EPSG:3301'
export const DATA_PROJECTION = 'EPSG:3301'

export const LAYERS = [
  {
    id: 'ma-map',
    label: 'Kaart',
    type: 'XYZ',
    projection: 'EPSG:3301',
    url: 'https://tiles.maaamet.ee/tm/tms/1.0.0/kaart/{z}/{x}/{-y}.png',
  },
  {
    id: 'ma-photo',
    label: 'Ortofoto',
    type: 'XYZ',
    projection: 'EPSG:3301',
    url: 'https://tiles.maaamet.ee/tm/tms/1.0.0/foto/{z}/{x}/{-y}.png',
  },
  {
    id: 'ma-bw',
    label: 'Hallkaart',
    type: 'XYZ',
    projection: 'EPSG:3301',
    url: 'https://tiles.maaamet.ee/tm/tms/1.0.0/hallkaart/{z}/{x}/{-y}.png',
  },
  {
    id: 'ma-terrain',
    label: 'Reljeef',
    type: 'Group',
    projection: 'EPSG:3301',
    layers: [
      {
        type: 'XYZ',
        url: 'https://tiles.maaamet.ee/tm/tms/1.0.0/vreljeef@LEST/{z}/{x}/{-y}.png',
      },
      {
        type: 'XYZ',
        url: 'https://tiles.maaamet.ee/tm/tms/1.0.0/hybriid@LEST/{z}/{x}/{-y}.png',
      },
    ],
  },
  {
    id: 'ma-soil',
    label: 'Mullaraster',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: 'https://kaart.maaamet.ee/wms/alus',
    params: {
      LAYERS: 'mullaraster',
      TILED: true,
      FORMAT: 'image/png',
      VERSION: '1.1.1',
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
  },
  {
    id: 'yldplaneering',
    label: 'Üldplaneeringud',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: 'https://teenus.maaamet.ee/ows/planeeringud',
    params: {
      LAYERS: 'YLD_Kehtiv_pohiplaan',
      TILED: true,
      FORMAT: 'image/png',
      VERSION: '1.1.1',
      TRANSPARENT: true,
      STYLES: '',
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
    //opacity: 0.85
  },
  {
    // Newer osaüldplaneeringud rasters (e.g. Tallinn linnaosa plans) drawn
    // over the base mosaic so the newest adopted plan is what shows (RED-293).
    id: 'yldplaneering-osaplan',
    label: 'Üldplaneeringud',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: 'https://teenus.maaamet.ee/ows/planeeringud',
    params: {
      LAYERS: 'YLD_Kehtiv_osaplan',
      TILED: true,
      FORMAT: 'image/png',
      VERSION: '1.1.1',
      TRANSPARENT: true,
      STYLES: '',
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
  },
  {
    // Digitized üldplaneering juhtotstarve polygons, colored. Explicit
    // per-category sublayers, never the server-side "maakas" group — the
    // group is broken upstream and silently drops categories (roheala among
    // them) its own members render; the official XGIS2 portal draws the
    // sublayers individually too. The XGIS2 service id rotates without
    // notice, so the three tier overlays below carry NO url on purpose: a
    // TileWMS without one requests nothing, and the Planeeringud card
    // applies the backend-resolved url + LAYERS (`overlay` in
    // /planning/{cadasterId}) to the one tier it switches on, re-resolving
    // when tiles fail. The last-known ids live in config/planning.php as the
    // backend's discovery fallback (RED-293).
    id: 'yp-maakasutus',
    label: 'Üldplaneeringu maakasutus',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    params: {
      LAYERS:
        'vfx2_digit_kiht_yp_maakas_elamu,vfx2_digit_kiht_yp_maakas_segahoonestus,vfx2_digit_kiht_yp_maakas_areng,vfx2_digit_kiht_yp_maakas_keskus,vfx2_digit_kiht_yp_maakas_yhiskond,vfx2_digit_kiht_yp_maakas_aiandus,vfx2_digit_kiht_yp_maakas_looduslik,vfx2_digit_kiht_yp_maakas_kaitsehaljastus,vfx2_digit_kiht_yp_maakas_roheala,vfx2_digit_kiht_yp_maakas_virgestus,vfx2_digit_kiht_yp_maakas_puhkeloodus,vfx2_digit_kiht_yp_maakas_puhkesport,vfx2_digit_kiht_yp_maakas_aritootmine,vfx2_digit_kiht_yp_maakas_ariteenindus,vfx2_digit_kiht_yp_maakas_liiklus,vfx2_digit_kiht_yp_maakas_tehno,vfx2_digit_kiht_yp_maakas_maetoostus,vfx2_digit_kiht_yp_maakas_jaatmehoidla,vfx2_digit_kiht_yp_maakas_turvas,vfx2_digit_kiht_yp_maakas_kalmistu,vfx2_digit_kiht_yp_maakas_riigikaitse',
      TILED: true,
      FORMAT: 'image/png',
      VERSION: '1.1.1',
      TRANSPARENT: true,
      STYLES: '',
    },
    tileSize: 1024,
    gutter: 20,
    tileRetry: true,
    visible: false,
    opacity: 0.8,
  },
  {
    // PLANK, the national planning register's maakasutus layer — the tier
    // below the digitized state layer: covers the municipalities it lacks
    // (Jõgeva, Rakvere, every plan filed since 2023). Same rotating XGIS2
    // ids, same card-applied url + self-heal as yp-maakasutus (RED-293).
    id: 'yp-maakasutus-plank',
    label: 'Üldplaneeringu maakasutus (PLANK)',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    params: {
      LAYERS: 'yp_maakasutus',
      TILED: true,
      FORMAT: 'image/png',
      VERSION: '1.1.1',
      TRANSPARENT: true,
      STYLES: '',
    },
    tileSize: 1024,
    gutter: 20,
    tileRetry: true,
    visible: false,
    opacity: 0.8,
  },
  {
    // Tallinn's own city GIS: the state datasets hold ZERO digitized Tallinn
    // ÜP land use, so the colored overlay for Tallinn comes from
    // gis.tallinn.ee (linnaosade ÜPs drawn over the 2001 citywide plan —
    // MapServer draws its own layer order). Single-image ArcGIS export like
    // egt-radon-risk; extent-gated to the service's Tallinn coverage so no
    // requests fire elsewhere (RED-293).
    id: 'yp-maakasutus-tallinn',
    label: 'Üldplaneeringu maakasutus (Tallinn)',
    type: 'ImageArcGISRest',
    projection: 'EPSG:3301',
    params: {
      LAYERS: 'show:0,1,3',
      FORMAT: 'png32',
      TRANSPARENT: true,
    },
    tileRetry: true,
    visible: false,
    opacity: 0.8,
    extent: [520000, 6579000, 556000, 6614000],
  },
  {
    // Tartu's own city GIS: the official ÜP 2040+ cartography (nine category
    // layers + the border layer 739), which outranks the state's digitized
    // copy inside Tartu. Same single-image ArcGIS export, extent-gated to
    // the service's coverage; url + LAYERS come from the backend (RED-293).
    id: 'yp-maakasutus-tartu',
    label: 'Üldplaneeringu maakasutus (Tartu)',
    type: 'ImageArcGISRest',
    projection: 'EPSG:3301',
    params: {
      LAYERS: 'show:739,738,737,736,735,734,733,732,731,730',
      FORMAT: 'png32',
      TRANSPARENT: true,
    },
    tileRetry: true,
    visible: false,
    opacity: 0.8,
    extent: [643800, 6468400, 663800, 6482800],
  },
  {
    id: 'ma-soil-color',
    label: 'Mullakaart',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: 'https://teenus.maaamet.ee/ows/mullakaart',
    params: {
      LAYERS: 'MULD_VEK_0,MULD_VEK_1,MULD_VEK_2',
      TILED: true,
      FORMAT: 'image/png',
      VERSION: '1.1.1',
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
    opacity: 0.5,
  },
  {
    id: 'ma-cadastre',
    label: 'Kataster',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: 'https://gsavalik.envir.ee/geoserver/kataster/wms',
    params: {
      LAYERS: 'ky_kehtiv,ky_aadress',
      TILED: true,
      FORMAT: 'image/png',
      VERSION: '1.1.1',
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
    // Cadastre/restriction detail is meaningless past city scale, and the
    // gsavalik composite renders are expensive server-side — never request
    // them for country-scale viewports (m/px; ≈ zoom 7+).
    maxResolution: 40,
    tileRetry: true,
  },
  {
    id: 'ma-tunnus',
    label: 'Kataster',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: 'https://gsavalik2.envir.ee/geoserver/kataster/wms',
    params: {
      LAYERS: 'ky_tunnus',
      TILED: true,
      FORMAT: 'image/png',
      VERSION: '1.1.1',
      TRANSPARENT: true,
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
    maxResolution: 40,
    tileRetry: true,
  },
  {
    id: 'ma-piir',
    label: 'Kataster',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: 'https://gsavalik.envir.ee/geoserver/kataster/wms',
    params: {
      LAYERS: 'ky_kehtiv',
      TILED: true,
      FORMAT: 'image/png',
      VERSION: '1.1.1',
      TRANSPARENT: true,
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
    maxResolution: 40,
    tileRetry: true,
  },
  {
    id: 'ma-omandivorm',
    label: 'Kataster',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: 'https://gsavalik2.envir.ee/geoserver/kataster/wms',
    params: {
      LAYERS: 'ky_omandivorm',
      TILED: true,
      FORMAT: 'image/png',
      VERSION: '1.1.1',
      TRANSPARENT: true,
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
    maxResolution: 40,
    tileRetry: true,
  },
  {
    id: 'ma-roads',
    label: 'Teeregister',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: '/proxy.php?url=https://teeregister.mnt.ee/teenus/wms',
    params: {
      LAYERS: 'n_alusdokumendid_ja_lepingud',
      FORMAT: 'image/png',
      VERSION: '1.1.1',
      TRANSPARENT: true,
      STYLES: '',
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
    opacity: 0.85,
  },
  {
    // State roads by class from Transpordiamet's own Teeregister WMS (same
    // stable host as ma-roads above). Replaces the retired xgis.maaamet.ee
    // a26r1d service (riigiteed_xgis,trassiosa — tiles 404'd on every
    // evaluation); the opaque XGIS2 service ids rotate, the named layers
    // here don't. trassiosa was only a centerline duplicate of the same
    // roads, so it has no equivalent layer on purpose (RED-293).
    id: 'ma-infras',
    label: 'Teeregister',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: 'https://teeregister.mnt.ee/teenus/wms',
    params: {
      LAYERS: 'Pohimaantee,Tugimaantee,Korvalmaantee,Muuriigitee,Ramp',
      FORMAT: 'image/png',
      VERSION: '1.1.1',
      TRANSPARENT: true,
      STYLES: '',
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
    opacity: 0.85,
  },
  {
    id: 'envir-kpo',
    label: 'Kitsendused',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: 'https://gsavalik.envir.ee/geoserver/kpokitsendused/wms',
    params: {
      LAYERS:
        'kpo_avalik_asjaoigus,kpo_avalik_elekter,kpo_avalik_gaas,kpo_avalik_geodeesia,kpo_avalik_kaugkyte,' +
        'kpo_avalik_kemikaal,kpo_avalik_looduskaitse,kpo_avalik_maaparandus,kpo_avalik_muinsuskaitse,' +
        'kpo_avalik_planeering,kpo_avalik_reostusoht,kpo_avalik_ressurss,kpo_avalik_riigikaitse,kpo_avalik_side,' +
        'kpo_avalik_transport,kpo_avalik_veekogu,kpo_avalik_veevarustus',
      TILED: true,
      FORMAT: 'image/png',
      VERSION: '1.1.1',
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
    maxResolution: 40,
    tileRetry: true,
  },
  {
    id: 'envir-kma-kpo',
    label: 'Kitsendused',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: 'https://gsavalik.envir.ee/geoserver/kmakitsendused/wms',
    params: {
      LAYERS:
        'kma_avalik_asjaoigus,kma_avalik_elekter,kma_avalik_gaas,kma_avalik_geodeesia,kma_avalik_kaugkyte,' +
        'kma_avalik_kemikaal,kma_avalik_looduskaitse,kma_avalik_maaparandus,kma_avalik_muinsuskaitse,' +
        'kma_avalik_reostusoht,kma_avalik_ressurss,kma_avalik_riigikaitse,kma_avalik_side,' +
        'kma_avalik_transport,kma_avalik_veekogu,kma_avalik_veevarustus',
      TILED: true,
      FORMAT: 'image/png',
      VERSION: '1.1.1',
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
    maxResolution: 40,
    tileRetry: true,
  },
  {
    id: 'ma-noise',
    label: 'Mürakaart',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: '/proxy.php?url=https://teenus.maaamet.ee/ows/myrakaart',
    params: {
      //LAYERS: 'myra22_strat_kast,myra22_strat_mnt_oopaev,myra22_strat_auto_oopaev,myra22_strat_rdt_oopaev,myra22_strat_toostus_oopaev,myra22_strat_lend_oopaev',
      LAYERS:
        'myra22_strat_mnt_oopaev,myra22_strat_auto_oopaev,myra22_strat_rdt_oopaev,myra22_strat_toostus_oopaev,myra22_strat_lend_oopaev',
      TILED: true,
      FORMAT: 'image/png',
      INFO_FORMAT: 'text/xml; subtype=gml/3.1.1',
      GEOM_NAME: 'msGeometry',
      VERSION: '1.1.1',
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
    opacity: 0.85,
  },
  {
    id: 'mnt-traffic',
    label: 'Liiklussagedus',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: '/proxy.php?url=https://teeregister.mnt.ee/teenus/wms',
    params: {
      LAYERS: 'n_liiklussagedus',
      TILED: true,
      FORMAT: 'image/png',
      INFO_FORMAT: 'geojson',
      VERSION: '1.1.1',
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
    opacity: 0.85,
  },
  {
    id: 'ma-minerals',
    label: 'Maardlad',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: '/proxy.php?url=https://teenus.maaamet.ee/ows/maardlad',
    params: {
      LAYERS: [
        'Aluspohja_savi',
        'Dolokivi',
        'J2rvelubi',
        'J2rvemuda',
        'Kruus',
        'Liiv',
        'Lubjakivi',
        'Maagaas',
        'Pinnakatte_savi',
        'Raud_ja_mangaan',
        'Turvas',
        'Varvipigment',
        'Fosforiit',
        'Meremuda',
        'Aluspohja_savi_levi',
        'Dolokivi_levi',
        'Fosforiit_levi',
        'J2rvelubi_levi',
        'J2rvemuda_levi',
        'Kristalliinne_ehituskivi_levi',
        'Kruus_levi',
        'Liiv_levi',
        'Lubjakivi_levi',
        'Polevkivi_levi',
        'Pinnakatte_savi_levi',
        'Turvas_levi',
        'Fe_Mn_konkretsioonid_levi',
        'Aluspohja_savi_persp',
        'Dolokivi_persp',
        'Fosforiit_persp',
        'J2rvelubi_persp',
        'J2rvemuda_persp',
        'Kristalliinne_ehituskivi_persp',
        'Kruus_persp',
        'Liiv_persp',
        'P6levkivi_persp',
        'Pinnakatte_savi_persp',
        'Turvas_persp',
        'Diatomiidi_persp',
        'Maaaines',
        'Vanaadium',
        'Tsink',
        'Uraan',
        'Plii',
        'Molybdeen',
        'PK_surfid',
        'PK_altkaevandatud',
        'PK_tervikud',
        'EP_altkaevandatud',
        'varud_polevkivi',
        'varud_fosforiit',
        'varud_lubjakivi_dolokivi',
        'varud_liiv_kruus',
        'varud_turvas',
        'varud_muu',
        'Ploki_piir',
        'maeeraldis_aktiivne',
        'maeeraldis_tm_aktiivne',
      ].join(','),
      TILED: true,
      FORMAT: 'image/png',
      INFO_FORMAT: 'text/xml; subtype=gml/3.1.1',
      GEOM_NAME: 'msGeometry',
      VERSION: '1.1.1',
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
    opacity: 0.85,
  },
  {
    id: 'ma-hazard',
    label: 'Ohtlikud käitised',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: '/proxy.php?url=https://teenus.maaamet.ee/ows/paasteamet-ohtvesi',
    params: {
      LAYERS:
        'OHTLIKKAITIS_OHUALA_C,OHTLIKKAITIS_C,OHTLIKKAITIS_OHUALA_B,OHTLIKKAITIS_C,OHTLIKKAITIS_OHUALA,OHTLIKKAITIS',
      TILED: true,
      FORMAT: 'image/png',
      INFO_FORMAT: 'application/vnd.ogc.gml',
      VERSION: '1.1.1',
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
    opacity: 0.85,
  },
  {
    id: 'envir-pollution',
    label: 'Jääkreostus',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: '/proxy.php?url=https://gsavalik2.envir.ee/geoserver/eelis/ows',
    params: {
      LAYERS: 'kr_jaakreostus',
      TILED: true,
      FORMAT: 'image/png',
      INFO_FORMAT: 'application/json',
      VERSION: '1.1.1',
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
    opacity: 0.85,
  },
  {
    // The same four Keskkonnaportaal layers the flood answer is computed from
    // (EsgDataController::FLOOD_PROBABILITY_LAYERS) and that Maa-amet's
    // yleujutusalad map draws; rarest first so the frequent bands stack on top.
    id: 'ma-flooding',
    label: 'Üleujutusalad',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: '/proxy.php?url=https://gsavalik.envir.ee/geoserver/keskkonnaportaal/wms',
    params: {
      LAYERS:
        'keskkonnaportaal:yleujutusalad_01,keskkonnaportaal:yleujutusalad_1,keskkonnaportaal:yleujutusalad_2,keskkonnaportaal:yleujutusalad_10',
      TILED: true,
      FORMAT: 'image/png',
      INFO_FORMAT: 'application/json',
      GEOM_NAME: 'shape',
      VERSION: '1.1.1',
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
    opacity: 0.85,
  },
  {
    id: 'egt-radon-risk',
    label: 'Radoonirisk',
    // ImageArcGISRest (single image per viewport) instead of TileArcGISRest:
    // gis.egt.ee throttles at ~10s of req/min and the QV history-export flow
    // would fan out 80+ tile requests at low zoom, returning HTTP 429 and
    // hanging the export. The KOV MapServer is dynamic (singleFusedMapCache
    // false), so tiling buys us nothing besides rate-limit pressure.
    type: 'ImageArcGISRest',
    projection: 'EPSG:3301',
    url: '/proxy.php?url=https://gis.egt.ee/arcgis/rest/services/Radoon/Rn_risk_KOV/MapServer',
    params: {
      LAYERS: 'show:1',
      FORMAT: 'png32',
      TRANSPARENT: true,
    },
    visible: false,
    opacity: 0.85,
  },
  {
    id: 'ma-heat',
    label: 'Soojussaared',
    type: 'TileWMS',
    projection: 'EPSG:3301',
    url: '/proxy.php?url=https://teenus.maaamet.ee/ows/soojussaared',
    params: {
      LAYERS: 'soojussaared_2024_juuni',
      TILED: true,
      FORMAT: 'image/png',
      INFO_FORMAT: 'text/gml',
      VERSION: '1.1.1',
    },
    tileSize: 1024,
    gutter: 20,
    visible: false,
    opacity: 0.85,
  },
  {
    id: 'transaction-features',
    type: 'FeatureCollection',
    features: [],
    style: null,
    clusters: true,
    webgl: true,
  },
  {
    id: 'transaction-comparison-features',
    type: 'FeatureCollection',
    features: [],
    style: null,
    clusters: true,
    webgl: true,
  },
  {
    id: 'detail-macro-features',
    type: 'FeatureCollection',
    label: 'Objekt',
    features: [],
    style: {
      stroke: {
        color: 'red',
        width: 2,
      },
    },
  },
  {
    id: 'detail-infra-features',
    type: 'FeatureCollection',
    features: [],
    style: null,
  },
  {
    id: 'detail-planning-features',
    type: 'FeatureCollection',
    features: [],
    style: {
      stroke: {
        color: 'red',
        width: 2,
      },
    },
  },
  {
    id: 'detail-micro-features',
    type: 'FeatureCollection',
    features: [],
    style: {
      transaction: {},
    },
  },
]

export const MAP_DEFAULT_BASELAYER = 'ma-map'

export const DETAIL_MACRO_MAP_INFO_LAYERS = []
export const DETAIL_MICRO_MAP_INFO_LAYERS = []
export const DETAIL_MACRO_MAP_FEATURE_LAYER = 'detail-macro-features'
export const DETAIL_MICRO_MAP_FEATURE_LAYER = 'detail-micro-features'

export const DETAIL_RESTRICTION_MAP_INFO_LAYERS = [
  'ma-cadastre',
  'envir-kpo',
  'envir-kma-kpo',
]
export const DETAIL_LANDBOARD_MAP_INFO_LAYERS = ['ma-cadastre']
export const DETAIL_LANDBOARD_MAP_FEATURE_LAYER = 'detail-macro-features'

export const DETAIL_INFRAS_MAP_INFO_LAYERS = [
  'ma-omandivorm',
  'ma-tunnus',
  'ma-piir',
  'ma-roads',
  'ma-infras',
]
export const DETAIL_INFRAS_MAP_FEATURE_LAYER = 'detail-infra-features'

// Bottom → top: base plan mosaic, newer osaplan rasters, colored digitized
// maakasutus, cadastre id + boundary lines (RED-293).
export const DETAIL_PLANNINGS_MAP_INFO_LAYERS = [
  'yldplaneering',
  'yldplaneering-osaplan',
  'yp-maakasutus',
  'yp-maakasutus-plank',
  'yp-maakasutus-tallinn',
  'yp-maakasutus-tartu',
  'ma-tunnus',
  'ma-piir',
]
// The vector overlays above; the card shows exactly the one the backend
// picked for the parcel (planningInfo.overlay.layerId), never all at once.
export const DETAIL_PLANNINGS_OVERLAY_LAYER_IDS = [
  'yp-maakasutus',
  'yp-maakasutus-plank',
  'yp-maakasutus-tallinn',
  'yp-maakasutus-tartu',
]
export const DETAIL_PLANNINGS_MAP_FEATURE_LAYER = 'detail-planning-features'

export const TRANSACTION_MAP_BASELAYERS = ['ma-map', 'ma-photo']
export const TRANSACTION_MAP_INFO_LAYERS = [
  'ma-soil',
  'ma-soil-color',
  'ma-cadastre',
]
export const TRANSACTION_MAP_FEATURE_LAYER = 'transaction-features'
export const TRANSACTION_MAP_COMPARISON_FEATURE_LAYER =
  'transaction-comparison-features'
export const TRANSACTION_MAP_SEARCH_HIGHLIGHT_LAYER =
  'transaction-search-highlight'
export const TRANSACTION_MAP_BROKER_OVERLAY_LAYER =
  'transaction-broker-overlay'
export const TRANSACTION_MAP_PARCEL_LAYER = 'transaction-parcel-boundaries'
export const TRANSACTION_MAP_HOVER_LAYER = 'transaction-hover-highlight'
// Zoom from which transactions render their cadastre outlines (RED-255)
export const TRANSACTION_MAP_PARCEL_ZOOM = 7
// Parcel fetches are pixel-culled server-side, so fetched ids are remembered
// per zoom band and re-checked when the user crosses into a finer band.
// Each band's cull resolution is taken at its `cullZoom` (the finest zoom of
// the band) so nothing visible anywhere inside the band is ever culled.
export const TRANSACTION_MAP_PARCEL_ZOOM_BANDS = [
  { min: 7, cullZoom: 9 },
  { min: 10, cullZoom: 12 },
  { min: 13, cullZoom: 16 },
]
// Zoom from which the map loads viewport-bboxed (instead of countrywide)
// and parcel fetches include small-cluster members
export const TRANSACTION_MAP_FULL_LOAD_ZOOM = 13
export const TRANSACTION_MAP_CONNECT_FEATURES_ZOOM = 8

export const TRANSACTION_FEATURE_ICONS = {
  default: [
    {
      icon: 'default',
      color: '#007bff',
    },
    {
      icon: 'chat-square',
      color: 'white',
    },
    {
      icon: 'house-fill',
      color: 'white',
      offset: [0, 2],
      scale: 0.5,
    },
  ],
  ad_link: [
    {
      icon: 'chat-square-fill',
      color: '#28a745',
    },
    {
      icon: 'chat-square',
      color: 'white',
    },
    {
      icon: 'house-fill',
      color: 'white',
      offset: [0, 2],
      scale: 0.5,
    },
  ],
  not_vabaturu_tehing: [
    {
      icon: 'chat-square-fill',
      color: '#6c757d',
    },
    {
      icon: 'chat-square',
      color: 'white',
    },
    {
      icon: 'house-fill',
      color: 'white',
      offset: [0, 2],
      scale: 0.5,
    },
  ],
  marked_for_comparison: [
    {
      icon: 'chat-square-fill',
      color: '#dc3545',
    },
    {
      icon: 'chat-square',
      color: 'white',
    },
    {
      icon: 'house-fill',
      color: 'white',
      offset: [0, 2],
      scale: 0.5,
    },
  ],
  cluster: [
    {
      icon: 'chat-square-fill',
      color: '#007bff',
    },
    {
      icon: 'chat-square',
      color: 'white',
    },
  ],
  cluster_ad_link: [
    {
      icon: 'chat-square-fill',
      color: '#28a745',
    },
    {
      icon: 'chat-square',
      color: 'white',
    },
  ],
  cluster_marked_for_comparison: [
    {
      icon: 'chat-square-fill',
      color: '#dc3545',
    },
    {
      icon: 'chat-square',
      color: 'white',
    },
  ],
}

export const TRANSACTION_KOM_FIELDS = [
  'tais_aadress',
  'tehingusumma',
  'hind_m2_korter',
  'sisaldab_km',
  'registriosa',
  'kpv',
  'aol_kpv',
  'lepingu_liik',
  'tehing',
  'korteri_pind',
  'objekti_liik',
  'omandiosa',
  'katastritunnused',
  'kinnistute_arv',
  'teised_ro_d',
  'pindala2',
  'muude_hoonete_selgitus',
  'muude_hoonete_arv',
  'tehingu_partnerid',
  'elamumaa_protsent',
  'arimaa_protsent',
  'tootmismaa_protsent',
  'maatulundusmaa_protsent',
  'muu_sihtotstarve_protsent',
  'markused',
  'notari_nimi',
  'notari_tehingu_nr',
]

export const TRANSACTION_KASI_T_FIELDS = [
  'tais_aadress',
  'tehingusumma',
  'sisaldab_km',
  'registriosa',
  'aol_kpv',
  'kpv',
  'lepingu_liik',
  'tehing',
  'objekti_liik',
  'omandiosa',
  'katastritunnused',
  'kinnistute_arv',
  'teised_ro_d',
  'pindala2',
  'muude_hoonete_selgitus',
  'muude_hoonete_arv',
  'tehingu_partnerid',
  'elamumaa_protsent',
  'arimaa_protsent',
  'tootmismaa_protsent',
  'maatulundusmaa_protsent',
  'muu_sihtotstarve_protsent',
  'haritav_maa_protsendiga',
  'metsamaa_protsendiga',
  'looduslik_rohumaa_protsendiga',
  'ouemaa_protsendiga',
  'muu_maa_protsendiga',
  'markused',
  'notari_nimi',
  'notari_tehingu_nr',
]

export const TRANSACTION_KASI_F_FIELDS = [
  'tais_aadress',
  'tehingusumma',
  'pindala2',
  'hind_yhik',
  'sisaldab_km',
  'registriosa',
  'katastritunnused',
  'aol_kpv',
  'lepingu_liik',
  'tehing',
  'kpv',
  'objekti_liik',
  'omandiosa',
  'kinnistute_arv',
  'teised_ro_d',
  'muude_hoonete_selgitus',
  'muude_hoonete_arv',
  'tehingu_partnerid',
  'elamumaa_protsent',
  'arimaa_protsent',
  'tootmismaa_protsent',
  'maatulundusmaa_protsent',
  'muu_sihtotstarve_protsent',
  'haritav_maa_protsendiga',
  'metsamaa_protsendiga',
  'looduslik_rohumaa_protsendiga',
  'ouemaa_protsendiga',
  'muu_maa_protsendiga',
  'markused',
  'notari_nimi',
  'notari_tehingu_nr',
]

export const RELATED_TRANSACTION_FIELDS = [
  'notari_nimi',
  'notari_tehingu_nr',
  'tais_aadress',
  'tehingusumma',
  'registriosa',
  'kpv',
  'aol_kpv',
  'lepingu_liik',
  'tehing',
  'objekti_liik',
  'omandiosa',
  'katastritunnused',
  'pindala2',
  'korteri_pind',
  'tehingu_partnerid',
  'markused',
]

export const TRANSACTION_EHR_BUILDING_FIELDS = [
  'ehr_kood',
  'ehitise_liik',
  'ehitise_nimetus',
  'ehitise_max_korruste_arv',
  // RED-235: building closed net area (suletud netopind), shown directly under
  // "Korruseid" (ehitise_max_korruste_arv) on the Ehitis tab — ONLY for an
  // üksikelamu (the row is gated in TransactionsEhrInfoComponent by the
  // building's is_house_for_area flag). The dwelling/eluruumi pind already
  // lives in the "Hooneosad" (building_parts) section below it.
  'ehitise_suletud_netopind',
  'building_parts',
  'ehitise_esmane_kasutus',
  'ehitise_kasutusotstarve',
  'ehitise_seisund',
  'ehitise_konstruktsioonide_materjal',
  'ehitise_valisseina_liik',
  'ehitise_seisukord',
  'ehitise_veevarustuse_liik',
  'ehitise_kanalisatsiooni_liik',
  'ehitise_soojusvarustuse_liik',
  'ehitise_gaasivarustus',
  'ehitise_ventilatsioon',
  'ehitise_jahutuse_liik',
  'ehitise_lift',
  'ehitise_energia_klass',
  'kinnistu_parkimine',
  'panipaik',
  'notes',
  'ehr_purpose',
]

export const TRANSACTION_EHR_BUILDING_PART_FIELDS = [
  'hooneosa_tubade_arv',
  'korrused',
  'hooneosa_pind',
  'hooneosa_koetav_pind',
  'rodu',
  'hooneosa_kookide_arv',
  'hooneosa_avatud_kookide_arv',
  'hooneosa_seisukord',
  'notes',
  'hooneosa_tualettruumide_liik',
  'hooneosa_pesemisvoimaluse_liik',
  'hooneosa_gaasipaigaldis',
  'hooneosa_soojavarustuse_liik',
  'hooneosa_soojusallika_liik',
  'hooneosa_energiaallika_liik',
]

export const TRANSACTION_EHR_BUILDING_PART_INPUTFIELDS = [
  'hooneosa_seisukord',
  'rodu',
]

export const TRANSACTION_EHR_FIELDS = [
  'ehr_kood',
  'hooneosa_tubade_arv',
  'korrused',
  'hooneosa_pind',
  'hooneosa_koetav_pind',
  'hooneosa_valipindade_pind',
  'hooneosa_kookide_arv',
  'hooneosa_avatud_kookide_arv',
  'hooneosa_seisukord',
  'ehitise_liik',
  'ehitise_nimetus',
  'ehitise_esmane_kasutus',
  'ehitise_kasutusotstarve',
  'ehitise_seisund',
  'ehitise_konstruktsioonide_materjal',
  'ehitise_valisseina_liik',
  'ehitise_seisukord',
  'ehitise_veevarustuse_liik',
  'ehitise_kanalisatsiooni_liik',
  'ehitise_soojusvarustuse_liik',
  'ehitise_gaasivarustus',
  'ehitise_ventilatsioon',
  'ehitise_jahutuse_liik',
  'ehitise_lift',
  'ehitise_energia_klass',
  'notes',
  'hooneosa_tualettruumide_liik',
  'hooneosa_pesemisvoimaluse_liik',
  'hooneosa_gaasipaigaldis',
  'hooneosa_soojavarustuse_liik',
  'hooneosa_soojusallika_liik',
  'hooneosa_energiaallika_liik',
  'ehr_purpose',
]

export const MARKED_TRANSACTION_KOM_FIELDS = [
  'aadress',
  'ad_link',
  'aol_kpv',
  'tehingusumma',
  'sisaldab_km',
  'm2hind',
  'korteri_pind',
  'hooneosa_pind',
  'hooneosa_tubade_arv',
  'korruste_arv',
  'kandekonstruktsioon',
  'ehitise_esmane_kasutus',
  'ehitise_seisukord',
  'hooneosa_seisukord',
  'hooneosa_valipindade_pind',
  'rodu',
  'koogimoobel',
  'kinnistu_parkimine',
  'panipaik',
  'tehnovorgud',
  'hooneosa_soojavarustuse_liik',
  'registriosa',
  'muu_info',
  'vordlustehingu_valik',
]

export const COMPARABLE_TRANSACTION_KOM_FIELDS = [
  'tehingusumma',
  'm2hind',
  'aol_kpv',
  'ajal_kohandus',
  'ajal_hind',
  'aadress',
  'ad_link',
  'asukoha_vordlus',
  'asukoha_kohandus',
  'kandekonstruktsioon',
  'kandekonstruktsioon_vordlus',
  'kandekonstruktsioon_kohandus',
  'ehitise_esmane_kasutus',
  'ehitise_seisukord',
  'ehitise_vordlus',
  'ehitise_kohandus',
  'vara_pind',
  'pindala_vordlus',
  'pindala_kohandus',
  'hooneosa_tubade_arv',
  'tubade_vordlus',
  'tubade_kohandus',
  'hooneosa_seisukord',
  'hooneosa_vordlus',
  'hooneosa_kohandus',
  'korruste_arv',
  'korruste_vordlus',
  'korruste_kohandus',
  'tehnovorgud',
  'tehnovorgud_vordlus',
  'tehnovorgud_kohandus',
  'hooneosa_soojavarustuse_liik',
  'hooneosa_soojavarustuse_vordlus',
  'hooneosa_soojavarustuse_kohandus',
  'rodu',
  'rodu_vordlus',
  'rodu_kohandus',
  'koogimoobel',
  'koogimoobel_vordlus',
  'koogimoobel_kohandus',
  'kinnistu_parkimine',
  'kinnistu_parkimine_vordlus',
  'kinnistu_parkimine_kohandus',
  'panipaik',
  'panipaik_vordlus',
  'panipaik_kohandus',
  'muu_info',
  'muu_info_vordlus',
  'muu_info_kohandus',
  'sum_kohandus',
  'kohandatud_hind',
  'kohanduse_abs',
  'kaalud',
  'kaalutud_keskmine',
  'turuvaartus',
]

// RED-267: Ostu-müügitehingute table row set for land (maatükk) evaluations.
// Ticket element order: Asukoht, Juurdepääs, Maatüki pindala m², Ehitusõigus,
// Tehnovõrgud, Haljastus, Muu — price/time/summary rows unchanged.
export const MARKED_TRANSACTION_LAND_FIELDS = [
  'aadress',
  'ad_link',
  'aol_kpv',
  'tehingusumma',
  'sisaldab_km',
  'm2hind',
  'juurdepaas',
  'maatuki_pindala',
  'ehitusoigus',
  'tehnovorgud',
  'haljastus',
  'registriosa',
  'muu_info',
  'vordlustehingu_valik',
]

// Ostu-müügitehingute table rows that are shown on screen only: the appraiser
// reads them, but they never reach the exported docx (Expert or Kiirhindamine)
// and are not editable. Mirrored by DocxService::SELECTION_TABLE_UI_ONLY_KEYS.
export const SELECTION_TABLE_UI_ONLY_FIELDS = ['registriosa']

export const MARKED_TRANSACTION_NUMERIC_FIELDS = [
  'tehingusumma',
  'm2hind',
  'sisaldab_km',
  'ajal_kohandus',
  'ajal_hind',
  'asukoha_kohandus',
  'hooneosa_kohandus',
  'korteri_pind',
  'hooneosa_pind',
  'pindala_kohandus',
  'hooneosa_tubade_arv',
  'tubade_kohandus',
  'korruste_kohandus',
  'ehitise_esmane_kasutus',
  'ehitise_kohandus',
  'kandekonstruktsioon_kohandus',
  'tehnovorgud_kohandus',
  'hooneosa_soojavarustuse_kohandus',
  'rodu_kohandus',
  'koogimoobel_kohandus',
  'kinnistu_parkimine_kohandus',
  'panipaik_kohandus',
  'muu_info_kohandus',
  'juurdepaas_kohandus',
  'ehitusoigus_kohandus',
  'haljastus_kohandus',
  'maatuki_pindala',
  'maatuki_pindala_kohandus',
  'sum_kohandus',
  'kohandatud_hind',
  'kohanduse_abs',
  'kaalud',
  'kaalutud_keskmine',
  'turuvaartus',
]

export const TRANSACTION_EHR_INPUTFIELDS = [
  'hooneosa_seisukord',
  'ehitise_seisukord',
  'kinnistu_parkimine',
  'panipaik',
  'notes',
]

export const DETAIL_DATE_FIELDS = [
  'ylevaatuse_kuupaev',
  'vaartuse_kuupaev',
  'aruande_kuupaev',
]

export const TRANSACTION_DATE_FIELDS = ['aol_kpv', 'kpv']

export const TRANSACTION_BOOLEAN_FIELDS = ['sisaldab_km']

export const TRANSACTION_LABEL_FIELDS = [
  'tehingusumma',
  'hind_yhik',
  'korteri_pind',
]

export const HEATMAP_GRADIENT = [
  'rgba(0, 0, 255, 0)',
  'rgba(0, 255, 255, 0.6)',
  'rgba(0, 255, 0, 0.7)',
  'rgba(255, 255, 0, 0.8)',
  'rgba(255, 128, 0, 0.9)',
  'rgba(255, 0, 0, 1)',
]

export const TRANSACTION_INFO_LINKS = {
  katastritunnused:
    'https://xgis.maaamet.ee/xgis2/page/app/maainfo?searchid=FUUKAT101x2&TUNNUS=${katastritunnused}&hide=true',
}

export const TRANSACTION_INFO_GOOGLE_SEARCH_KV = [
  {
    label: 'messages.transactions.fields.katastritunnused',
    href: 'https://www.google.com/search?q=site:kv.ee ${katastritunnused}',
  },
  {
    label: 'messages.transactions.google.address.apartment_size',
    href: 'https://www.google.com/search?q=site:kv.ee ${aadress} ${maja_number}, ${korteri_pind}',
    type: 'KOM',
  },
  {
    label: 'messages.transactions.google.address.apartment',
    href: 'https://www.google.com/search?q=site:kv.ee ${aadress} ${maja_number}',
  },
  {
    label: 'messages.transactions.google.address.house',
    href: 'https://www.google.com/search?q=site:kv.ee müüa maja ${aadress} ${maja_number}',
    type: 'KASI',
  },
  {
    label: 'messages.transactions.google.address.house_cadastral_code',
    href: 'https://www.google.com/search?q=site:kv.ee müüa maja ${aadress} ${maja_number} ${katastritunnused}',
    type: 'KASI',
  },
]

export const TRANSACTION_INFO_GOOGLE_SEARCH = [
  {
    label: 'messages.transactions.fields.katastritunnused',
    href: 'https://www.google.com/search?q=${katastritunnused}',
  },
  {
    label: 'messages.transactions.google.address.apartment_size',
    href: 'https://www.google.com/search?q=${aadress} ${maja_number}, ${korteri_pind}',
    type: 'KOM',
  },
  {
    label: 'messages.transactions.google.address.apartment',
    href: 'https://www.google.com/search?q=${aadress} ${maja_number}',
  },
  {
    label: 'messages.transactions.google.address.apartment_size_rooms_floor',
    href: 'https://www.google.com/search?q=müüa korter, ${buildingPart.hooneosa_tubade_arv} tuba, ${aadress} ${maja_number}, ${korteri_pind}, ${buildingPart.hooneosa_sissepaasu_korrus}/${building.ehitise_max_korruste_arv}',
    type: 'KOM',
  },
  {
    label: 'messages.transactions.google.address.apartment_rooms_floor',
    href: 'https://www.google.com/search?q=müüa korter, ${buildingPart.hooneosa_tubade_arv} tuba, ${aadress} ${maja_number}, ${buildingPart.hooneosa_sissepaasu_korrus}/${building.ehitise_max_korruste_arv}',
    type: 'KOM',
  },
  {
    label: 'messages.transactions.google.address.apartment_size_rooms',
    href: 'https://www.google.com/search?q=müüa korter, ${buildingPart.hooneosa_tubade_arv} tuba, ${aadress} ${maja_number}, ${korteri_pind}',
    type: 'KOM',
  },
]

export const TRANSACTION_INFO_GOOGLE_SEARCH_KV_MAP = {
  asukoht: [
    { find: 'Harju maakond', to: 'Harjumaa' },
    { find: 'Hiiu maakond', to: 'Hiiumaa' },
    { find: 'Ida-Viru maakond', to: 'Ida-Virumaa' },
    { find: 'Jõgeva maakond', to: 'Jõgevamaa' },
    { find: 'Järva maakond', to: 'Järvamaa' },
    { find: 'Lääne maakond', to: 'Läänemaa' },
    { find: 'Lääne-Viru maakond', to: 'Lääne-Virumaa' },
    { find: 'Põlva maakond', to: 'Põlvamaa' },
    { find: 'Pärnu maakond', to: 'Pärnumaa' },
    { find: 'Rapla maakond', to: 'Raplamaa' },
    { find: 'Saare maakond', to: 'Saaremaa' },
    { find: 'Tartu maakond', to: 'Tartumaa' },
    { find: 'Valga maakond', to: 'Valgamaa' },
    { find: 'Viljandi maakond', to: 'Viljandimaa' },
    { find: 'Võru maakond', to: 'Võrumaa' },
  ],
}

export const TRANSACTION_INFO_FOTOLADU =
  'https://fotoladu.maaamet.ee/api.php?x=${x}&y=${y}'

export const DETAIL_EXTERNAL_LINKS = {
  externalLandBoard:
    'https://xgis.maaamet.ee/xgis2/page/app/maainfo?searchid=FUUKAT101x2&TUNNUS=${cadasterId}&hide=true',
  externalRestrictions:
    'https://kitsendused.maaamet.ee/#/avalik;ky=${cadasterId}',
  externalPlans:
    'https://xgis.maaamet.ee/xgis2/page/app/planeeringud?searchid=FUUKAT101x2&TUNNUS=${cadasterId}&hide=true',
  externalWoods: 'https://register.metsad.ee/#/?kataster=${cadasterId}',
  externalSoil:
    'https://xgis.maaamet.ee/xgis2/page/app/mullakaart?searchid=FUUKAT101x2&TUNNUS=${cadasterId}&hide=true',
  externalTransportAdministration:
    'https://xgis.maaamet.ee/xgis2/page/app/maanteeamet?searchid=FUUKAT101x2&TUNNUS=${cadasterId}&hide=true',
  externalEHR: 'https://livekluster.ehr.ee/ui/ehr/v1/building/${ehrId}',
  externalHeatIslands:
    'https://xgis.maaamet.ee/xgis2/page/app/soojussaared?searchid=FUUKAT101x2&TUNNUS=${cadasterId}&hide=true',
  externalFlood:
    'https://xgis.maaamet.ee/xgis2/page/app/yleujutusalad?searchid=FUUKAT101x2&TUNNUS=${cadasterId}&hide=true',
}

export const DETAIL_ESG = {
  noise_level: {
    layers: ['ma-noise'],
    legends: ['https://redata.ee/images/static/noise-map-legend.png'],
    base_layers: ['ma-map'],
    link: 'https://xgis.maaamet.ee/xgis2/page/app/myrakaart?searchid=FUUKAT101x2&TUNNUS=${cadasterId}&hide=true',
    feature_info: 'WFS',
  },
  traffic_volume: {
    layers: ['mnt-traffic'],
    legends: [
      'https://teeregister.mnt.ee/teenus/wms?SERVICE=WMS&VERSION=1.3.0&SLD_VERSION=1.1.0&REQUEST=GetLegendGraphic&FORMAT=image%2Fpng&LAYER=n_liiklussagedus&SCALE=871.9308035714287',
    ],
    base_layers: ['ma-photo'],
    link: 'https://xgis.maaamet.ee/xgis2/page/app/teeregister?searchid=FUUKAT101x2&TUNNUS=${cadasterId}&hide=true',
    feature_info: 'WMS',
  },
  mineral_deposit: {
    layers: ['ma-minerals'],
    legends: ['Dolokivi', 'Kruus', 'Liiv', 'Lubjakivi', 'Turvas'].map(
      layerName =>
        `https://teenus.maaamet.ee/ows/maardlad?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=${layerName}&format=image/png&STYLE=default`,
    ),
    base_layers: ['ma-photo'],
    link: 'https://xgis.maaamet.ee/xgis2/page/app/maardlad?searchid=FUUKAT101x2&TUNNUS=${cadasterId}&hide=true',
    feature_info: 'WFS',
  },
  hazardous_installations: {
    layers: ['ma-hazard'],
    base_layers: ['ma-photo'],
    legends: [
      'https://teenus.maaamet.ee/ows/paasteamet-ohtvesi?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=OHTLIKKAITIS_OHUALA&format=image/png&STYLE=default',
      'https://teenus.maaamet.ee/ows/paasteamet-ohtvesi?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=OHTLIKKAITIS_OHUALA_B&format=image/png&STYLE=default',
      'https://teenus.maaamet.ee/ows/paasteamet-ohtvesi?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=OHTLIKKAITIS_OHUALA_C&format=image/png&STYLE=default',
    ],
    link: 'https://xgis.maaamet.ee/xgis2/page/app/paasteamet_ohtvesi?searchid=FUUKAT101x2&TUNNUS=${cadasterId}&hide=true',
    feature_info: 'WMS',
  },
  residual_pollution: {
    layers: ['envir-pollution'],
    base_layers: ['ma-photo'],
    feature_info: 'WMS',
  },
  radon_risk: {
    layers: ['egt-radon-risk'],
    legends: [
      { color: 'rgb(255, 46, 43)', label: 'Rn-risk on kõrge või väga kõrge' },
      { color: 'rgb(195, 199, 195)', label: 'Rn-risk on täiendav uuringuvajadus' },
      { color: 'rgb(111, 191, 65)', label: 'Rn-risk on keskmine või madal' },
    ],
    base_layers: ['ma-photo'],
    feature_info: 'WMS',
  },
  flood_risk: {
    layers: ['ma-flooding'],
    legends: [
      'https://gsavalik.envir.ee/geoserver/keskkonnaportaal/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image/png&width=20&height=20&layer=yleujutusalad_01',
    ],
    base_layers: ['ma-terrain'],
    link: 'https://xgis.maaamet.ee/xgis2/page/app/yleujutusalad?searchid=FUUKAT101x2&TUNNUS=${cadasterId}&hide=true',
    feature_info: 'WMS',
  },
  heat_islands: {
    layers: ['ma-heat'],
    legends: [
      'https://teenus.maaamet.ee/ows/soojussaared?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=soojussaared_2024_juuni&format=image/png&STYLE=default',
    ],
    base_layers: ['ma-photo'],
    link: 'https://xgis.maaamet.ee/xgis2/page/app/soojussaared?searchid=FUUKAT101x2&TUNNUS=${cadasterId}&hide=true',
    feature_info: 'WMS',
  },
}

// Planeeringud card legend (RED-293 r6): rendered server-side at RENDER_SCALE
// times the compact docx size and shown at DISPLAY_SCALE times it, so the
// enlarged legend stays crisp on HiDPI screens instead of a blurry upscale.
export const PLANNING_LEGEND_RENDER_SCALE = 3
export const PLANNING_LEGEND_DISPLAY_SCALE = 1.5
